export default function (_a) {
    var env = _a.env, data = _a.data, outputs = _a.outputs, inputs = _a.inputs, onError = _a.onError;
    inputs['params'](function (val, relOutpus) {
        var _a, _b, _c, _d, _e;
        if (!data.appId || !data.appSecret) {
            return onError('appID和appSecret是必填项，请检查配置');
        }
        if (!!!val || typeof val !== 'string') {
            return onError('小程序登录凭证不存在，请检查输入项');
        }
        try {
            (_d = (_c = (_b = (_a = env.services) === null || _a === void 0 ? void 0 : _a.wechatMiniapp) === null || _b === void 0 ? void 0 : _b.code2Session) === null || _c === void 0 ? void 0 : _c.call(_b, val, data.appId, data.appSecret)) === null || _d === void 0 ? void 0 : _d.then(function (result) {
                if (result === null || result === void 0 ? void 0 : result.errcode) {
                    return onError("\u5C0F\u7A0B\u5E8F\u767B\u5F55\u5931\u8D25[".concat(result.errcode, "]\uFF1A").concat(result.errmsg));
                }
                relOutpus['rtn'](result);
            });
        }
        catch (error) {
            onError("\u5C0F\u7A0B\u5E8F\u767B\u5F55\u8C03\u7528\u5931\u8D25\uFF1A".concat((_e = error === null || error === void 0 ? void 0 : error.message) !== null && _e !== void 0 ? _e : '未知错误'));
        }
    });
}
